import React from "react";
import "./Switch.css";

const Switch = (props) => {
  return (
    <>
      <input
        checked={props.isOn}
        onChange={props.handleToggle}
        type="checkbox"
        id={"react-switch-id-" + props.shiftId}
        className="react-switch-checkbox"
      />
      <label
        style={{ background: props.isOn && props.onColor }}
        className="react-switch-label"
        htmlFor={"react-switch-id-" + props.shiftId}
      >
        <span className={"react-switch-button"} />
      </label>
    </>
  );
};

export default Switch;
